module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-next-21b81701c7f34490325275fbb5f5cdda.svg";